<template>
	<a-modal width="45%" title="审核信息" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :footer="null">
		<a-descriptions :column="2">
			<a-descriptions-item label="审核结果" :span="2">{{ form.auditStatus == 0 ? '待审核' : form.auditStatus == 1 ? '审核通过' :
				'审核不通过' }}</a-descriptions-item>
			<a-descriptions-item label="审核意见" :span="2">{{ form.auditStatusNote }}</a-descriptions-item>
		</a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin } from "@/mixins";

export default {
	name: "AddOrEditModal",
	components: {},

	mixins: [formMixin],
	data() {
		return {
			form: {
				id: null,
			},
		}
	},
}
</script>
<style scoped lang="less"></style>
